import { useParams } from "react-router-dom";
import { useCurrentUser } from "../../../hooks";
import { useCompanyData } from "../../../hooks/useCompanyData";
import { useUsers } from "../../users/hooks/useUsers";
import { getInitials } from "../utils/csvAndDateUtils";

export const useCompanyOverview = (): {
  user: ReturnType<typeof useCurrentUser>["user"];
  company: ReturnType<typeof useCompanyData>["company"];
  organizationName: string;
  organizationKey: string;
  initials: string;
  organizationLogoUrl: string | undefined;
  internalUsersCount: number;
  loading: boolean;
} => {
  const { companyId } = useParams();
  const { user, isLoading: userLoading } = useCurrentUser();
  const { company, isLoading: companyLoading } = useCompanyData(
    companyId,
    true,
  );

  /** USERS **/
  const { users, isLoading: usersLoading } = useUsers({
    companyId: companyId ?? "",
    pageSize: 1000,
    enabled: !!companyId,
  });

  const internalUsersCount = users.length;

  const organizationName = company?.friendlyName ?? user?.companyName ?? "—";
  const organizationKey = company?.companyKey ?? "—";
  const initials = getInitials(organizationName);
  const organizationLogoUrl = company?.libraryCardURL ?? undefined;

  const loading = userLoading || companyLoading || usersLoading;

  return {
    user,
    company,
    organizationName,
    organizationKey,
    initials,
    organizationLogoUrl,
    internalUsersCount,
    loading,
  };
};
